import { render } from "./TableItem.vue?vue&type=template&id=610968ff&scoped=true&ts=true"
import script from "./TableItem.vue?vue&type=script&lang=ts"
export * from "./TableItem.vue?vue&type=script&lang=ts"

import "./TableItem.vue?vue&type=style&index=0&id=610968ff&scoped=true&lang=css"

import exportComponent from "D:\\onepack\\hotaru_theme-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610968ff"]])

export default __exports__